import React, { useEffect, useState } from "react";
import "../paymentLink/paymentLinks.css";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/API_Client";
import LoadingLogoPage from "../loadingPage/loadingPage";
import InsertLinkIcon from "@mui/icons-material/InsertLink";
import EmptyState from "../../reusableComponents/ConfigEmptyState/EmptyState";
import TablePaymentLink from "./tablePaymentLink";
import { isEmpty, PAGE_LIST } from "../utils/utils";
import { customToast } from "../../reusableComponents/customToaster/customToast";
import { colorBrandObject } from "../../../constants/brandings";

function PaymentLinks(operationPermissions) {
  const { getAllVisualizationData, merchantSettings, isAuthorizedPermission } = useAuth();
  const [oneTimePaymentLinkData, setOneTimePaymentLinkData] = useState();
  const [multiplePaymentLinkData, setMultiplePaymentLinkData] = useState();
  const [loading, setLoading] = useState(true);
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  let toDate = new Date();
  toDate.setHours(23, 59, 59, 999);
  let fromDate = new Date(toDate);
  fromDate.setMonth(fromDate.getMonth() - 13);
  fromDate.setHours(0, 0, 0, 0);
  const [timeZone, setTimeZone] = useState();
  const [totalDataCount, setTotalDataCount] = useState(100);
  const [pageNo, setPageNo] = useState(1);
  const [pageLimit, setPageLimit] = useState(PAGE_LIST[2]);
  const [paymentDetailsAvailable, setPaymentDetailsAvailable] = useState(false);
  const [isMultiPaymentLinkDataAvailable, setIsMultiPaymentLinkDataAvailable] = useState(false);
  const [isMultiPaymentLinkTabActive, setIsMultiPaymentLinkTabActive] = useState(false);

  const getPaymentLinkData = (isLoading, multiPayment) => {
    if (isLoading) setLoading(true)
    getAllVisualizationData(
      "payment_links",
      {
        fromDate,
        toDate,
        attributeFilters: { multipleTransaction: multiPayment },
        sort: {
          addedTimestamp: "desc",
        },
        limit: pageLimit, // pagination
        offset: (pageNo - 1) * pageLimit // pagination
      },
      function (paymentDetails) {
        if (!paymentDetailsAvailable && paymentDetails?.points?.length) {
          setPaymentDetailsAvailable(true);
        }
        if (multiPayment && !isEmpty(paymentDetails.points)) {
          setIsMultiPaymentLinkDataAvailable(true);
          setMultiplePaymentLinkData(paymentDetails);
        } else if (!multiPayment && !isEmpty(paymentDetails.points)) {
          setOneTimePaymentLinkData(paymentDetails);
        }
        setLoading(false);
      },
      (errorMsg) => {
        setOneTimePaymentLinkData(errorMsg);
      },
      operationPermissions
    );
  }

  useEffect(() => {
    if (isEmpty(oneTimePaymentLinkData) && isEmpty(multiplePaymentLinkData)) return
    if (isMultiPaymentLinkTabActive) {
      setTotalDataCount(multiplePaymentLinkData.totalCount);
    } else {
      setTotalDataCount(oneTimePaymentLinkData?.totalCount);
    }
  }, [isMultiPaymentLinkTabActive, oneTimePaymentLinkData, multiplePaymentLinkData])
  useEffect(() => {
    merchantSettings(
      function (data) {
        setTimeZone(data?.timeZone);
        fromDate = fromDate;
        toDate = toDate;
      },
      function (errMsg) {
        customToast("error", "high", errMsg);
      }
    );

  }, []);

  useEffect(() => {
    getPaymentLinkData(false, true)
    getPaymentLinkData(false, false)
  }, [])

  const navigate = useNavigate();
  return (
    <>
      {!loading && paymentDetailsAvailable ? (
        <TablePaymentLink
          oneTimePaymentLinkData={oneTimePaymentLinkData?.points}
          multiplePaymentLinkData={multiplePaymentLinkData?.points}
          isMultiPaymentLinkDataAvailable={isMultiPaymentLinkDataAvailable}
          timeZone={timeZone}
          operationPermissions={operationPermissions}
          getPaymentDetails={getPaymentLinkData}
          setTotalDataCount={setTotalDataCount}
          totalDataCount={totalDataCount}
          pageNo={pageNo}
          pageLimit={pageLimit}
          setPageNo={setPageNo}
          setPageLimit={setPageLimit}
          isMultiPaymentLinkTabActive={isMultiPaymentLinkTabActive}
          setIsMultiPaymentLinkTabActive={setIsMultiPaymentLinkTabActive}
        />
      ) : (
        <div className="content-wrapper" style={{ backgroundColor: "white" }}>
          <section className="content">
            {loading ? (
              <LoadingLogoPage />
            ) : (
              <div className="mainDiv">
                <EmptyState
                  image={
                    <InsertLinkIcon
                      sx={{
                        color: colorBrandObject.sideBarSelectedOptionBackground,
                        height: "120px",
                        width: "120px",
                      }}
                    />
                  }
                  mainText={" Get paid instantly with your unique Payment Link"}
                  subText={" Create and share your unique payment link with customers to accept payments"}
                  btnText={"Create Link"}
                  btnFunction={() =>
                    navigate("/paymentLinks/createPaymentlink")
                  }
                  btnPermission={operationPermissions?.createPaymentLink}
                  showCustomDropdownlist={true}
                />
              </div>
            )}
          </section>
        </div>
      )}
    </>
  );
}
export default PaymentLinks;
